const BEST_KEY = "wordphysics.best";
const DAILY_KEY = "wordphysics.daily";

export type BestRecords = Record<string, number>;
export type DailyRecords = Record<string, number>;

function readJSON<T>(key: string, fallback: T): T {
  try { return (JSON.parse(localStorage.getItem(key) ?? "null") as T | null) ?? fallback; }
  catch { return fallback; }
}

function writeJSON(key: string, value: unknown) {
  try { localStorage.setItem(key, JSON.stringify(value)); }
  catch { /* Storage can be unavailable in private browsing. */ }
}

/** Keeps the most shots left over for a stage; returns the updated map and whether it is a new best. */
export function recordBest(records: BestRecords, id: string, shotsLeft: number): { records: BestRecords; improved: boolean } {
  const previous = records[id];
  if (previous !== undefined && previous >= shotsLeft) return { records, improved: false };
  return { records: { ...records, [id]: shotsLeft }, improved: previous !== undefined };
}

/** Consecutive cleared days ending today, or ending yesterday when today is not cleared yet. */
export function dailyStreak(records: DailyRecords, today: string): number {
  const day = new Date(`${today}T12:00:00`);
  if (records[today] === undefined) day.setDate(day.getDate() - 1);
  let streak = 0;
  for (;;) {
    const pad = (value: number) => String(value).padStart(2, "0");
    const key = `${day.getFullYear()}-${pad(day.getMonth() + 1)}-${pad(day.getDate())}`;
    if (records[key] === undefined) return streak;
    streak += 1;
    day.setDate(day.getDate() - 1);
  }
}

export const readBestRecords = () => readJSON<BestRecords>(BEST_KEY, {});
export const writeBestRecords = (value: BestRecords) => writeJSON(BEST_KEY, value);
export const readDailyRecords = () => readJSON<DailyRecords>(DAILY_KEY, {});
export const writeDailyRecords = (value: DailyRecords) => writeJSON(DAILY_KEY, value);
